import Link from 'next/link'
import { formatDateMM_DD_YYYY } from 'src/common/dateFormat'
import logger from 'src/common/logger'
import Layout from 'src/components/layouts'
import AuthorsRepository from 'src/repositories/AuthorsRepository'
import PageRepository from 'src/repositories/PageRepository'
import Pagination from '../../src/components/shared/Pagination'

const POSTS_PER_PAGE = 26 // Limit for items per page
const PAGES = [
  {
    key: 'home',
    path: '/',
    title: 'Home',
  },
  {
    key: 'about',
    path: '/about/',
    title: 'About',
  },
  {
    key: 'contact',
    path: '/contact/',
    title: 'Contact',
  },
  {
    key: 'client-faq',
    path: '/client-faq/',
    title: 'Client FAQ',
  },
  {
    key: 'debt-consolidation-loan',
    path: '/debt-consolidation-loan/',
    title: 'Debt Consolidation Loan',
  },
  {
    key: 'debt-management-guide',
    path: '/debt-management-guide/',
    title: 'Debt Management Guide',
  },
  {
    key: 'faq',
    path: '/faq/',
    title: 'FAQ',
  },
  {
    key: 'freedom-debt-guide-download',
    path: '/freedom-debt-guide-download/',
    title: 'Freedom Debt Guide Download',
  },
  {
    key: 'freedom-debt-guide-success',
    path: '/freedom-debt-guide-success/',
    title: 'Freedom Debt Guide Success',
  },
  {
    key: 'freedom-debt-relief-executives',
    path: '/freedom-debt-relief-executives/',
    title: 'Freedom Debt Relief Executives',
  },
  {
    key: 'how-it-works',
    path: '/how-it-works/',
    title: 'How It Works',
  },
  {
    key: 'partner-with-the-leader-in-debt-resolution',
    path: '/partner-with-the-leader-in-debt-resolution/',
    title: 'Partner With The Leader In Debt Resolution',
  },
  {
    key: 'scam',
    path: '/scam/',
    title: 'Scam',
  },
  {
    key: 'take-action',
    path: '/take-action/',
    title: 'Take Action',
  },
  {
    key: 'testimonials',
    path: '/testimonials/',
    title: 'Testimonials',
  },
  {
    key: 'why-were-better',
    path: '/why-were-better/',
    title: 'Why Were Better',
  },
  {
    key: 'who-we-help',
    path: '/who-we-help/',
    title: 'Who We Help',
  },
  {
    key: 'who-we-help/states',
    path: '/who-we-help/states/',
    title: 'States',
  },
  {
    key: 'debt-consolidation',
    path: '/debt-consolidation/',
    title: 'Debt Consolidation',
  },
  {
    key: 'blog',
    path: '/blog',
    title: 'Blog',
  },
]

export async function getServerSideProps({ params: { pid: page = 1 } }) {
  const currentPage = Number(page[1]) || 1
  const skip = currentPage === 1 ? 0 : (currentPage - 1) * 40 - 20
  let dynamicPages = []
  let total = PAGES.length // Start total with the static pages count
  console.log('total, allPages', skip, currentPage, page)

  try {
    // Fetch paginated dynamic pages
    const pageResponse = await PageRepository.getInstance().getModels({
      limit: currentPage === 1 ? 20 : 40,
      skip,
      'fields.model[exists]': true,
      'fields.template[in]': `${['blog', 'evergreen', 'geo']}`,
    })

    // Fetch authors separately (non-paginated)
    const authorsResponse = await AuthorsRepository.getInstance().getModels({
      limit: 1000,
    })

    // Map dynamic pages
    dynamicPages = pageResponse.map((item) => ({
      key: item.key,
      path: '/' + item.path,
      title: item.model.title,
    }))

    // Map authors
    const authors = authorsResponse.map((author) => ({
      key: author.key,
      path: '/author/' + author.slug,
      title: author.fullName,
    }))

    // Update total count
    total += pageResponse.length + authors.length

    // Combine static pages, dynamic pages, and authors
    const allPages =
      currentPage === 1 ? [...PAGES, ...authors, ...dynamicPages] : dynamicPages

    console.log(total)

    return {
      props: {
        pages: allPages,
        date: formatDateMM_DD_YYYY(new Date()),
        currentPage,
        total,
      },
    }
  } catch (error) {
    logger.error('Sitemap server side: Something went wrong', {
      error: error.message,
      stack: error.stack,
    })

    return {
      props: {
        pages: PAGES, // Fallback to static pages
        date: formatDateMM_DD_YYYY(new Date()),
        currentPage,
        total,
      },
    }
  }
}

export default function Page({ pages, date, currentPage, total }) {
  {
    console.log({ total })
  }

  return (
    <Layout
      crawlable={true}
      isBrandPage={true}
      footerClassName="mb-5 lg:mb-0"
      dashboardClass="bg-blue-300 text-white"
    >
      <div className="mx-auto mb-12 max-w-screen-sm px-3">
        <h1 className="mb-5 pt-10 text-center text-4xl font-normal text-blue-700">
          Freedom Debt Relief Sitemap
        </h1>
        <span className="text-sm text-gray-500">
          <b>Last Updated:</b> {date}
        </span>
        <ul className="mt-4 list-disc space-y-3 pl-9 marker:text-gray-510">
          {pages.map((page) => (
            <li key={page.key} className="text-sm font-medium text-blue-560">
              <Link href={page.path}>{page.title}</Link>
            </li>
          ))}
        </ul>
        <Pagination
          itemCount={total}
          currentPageNumber={currentPage}
          postsLimit={POSTS_PER_PAGE}
        />
      </div>
    </Layout>
  )
}
